<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Occupation Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.occp }}</td>
          <td class="text-xs-left">{{ props.item.occpDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.occp)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Occupation
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="showOccpDialog" width="800px" lazy persistent v-if="checkAccess(['fireRatingReview'])">
      <v-card>
        <v-card-title>
          <span class="headline">Construction Class</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newOccp">
                <v-text-field :label="labels.occp" v-model="form.occp" :error-messages="errors.collect('occp')"
                  data-vv-name="occp" :data-vv-as="labels.occp" v-validate="'required|max:2'"/>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.occp}}</v-subheader>
                <div class="title">{{form.occp}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.occpDesc" v-model="form.occpDesc" :error-messages="errors.collect('occpDesc')"
                  data-vv-name="occpDesc" :data-vv-as="labels.occpDesc" v-validate="'required|max:60'"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Occupation', value: 'occp' },
        { text: 'Description', value: 'occpDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        occp: 'Occupation*',
        occpDesc: 'Description*'
      },
      newOccp: false,
      showOccpDialog: false,
      form: {
        occp: null,
        occpDesc: null
      },
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiUrl = this.menu.occupations
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (result.data) {
            this.items = []
            data.map(occp => {
              const convertList = {
                occp: occp.occp,
                occpDesc: occp.occpDesc
              }
              this.items.push(convertList)
            })
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    doNew() {
      this.showOccpDialog = this.newOccp = true
      this.form.occp = this.form.occpDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    async doReview(occp) {
      const apiURI = this.menu.occupation
      this.newOccp = false
      if (apiURI) {
        const expand = {
          occp
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.form.occp = data.occupation.occp
          this.form.occpDesc = data.occupation.occpDesc
          this.showOccpDialog = true
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newOccp) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createOccupation
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateOccupation
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(occp) {
      this.resetMessages()
      this.selectedId.id = occp.occp
      this.selectedId.text = occp.occp + ' - ' + occp.occpDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.menu.deleteOccupation
      if (apiURI) {
        const expand = {
          occp: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.doFetch()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doClose() {
      this.showOccpDialog = this.newOccp = false
      this.form.occp = this.form.occpDesc = null
      this.resetValidator()
      this.resetMessages()
    }
  },
  mounted() {
    this.doFetch()
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    menu() {
      return this.$store.state.pa.menu
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
